import React, {Component} from "react";
import { injectIntl } from "react-intl";

class EmptyFolders extends Component{
    
    render(){
        const {
            intl
        } = this.props;
        return (
            <div
                style = {{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    height: 300,
                    backgroundColor: "#D9D9D95C",
                }}
            >
                <p style = {{
                    fontSize: 20,
                    fontWeight: 700,
                    color: "#6F6F6F",
                }}>
                    {intl.formatMessage({id: "upload-folder-s2-empty"})}
                </p>
            </div>
        )
    }
}

export default injectIntl(EmptyFolders);